module.exports = __webpack_public_path__ + "fonts/SourceSansPro-SemiBold.43cc81b.ttf";